<template>
  <mdb-container fluid v-bind:style="{fontFamily: 'OpenSans-Regular', fontSize: '12px'}">
    <h2 class="mt-lg-4" style="font-family: OpenSans-bold; margin-bottom: -10px;">
      <strong>Obras</strong>
    </h2>
    <!--Section: Horizontal stepper-->
    <section class="my-5">
      <!--Card-->
      <mdb-card class="card-person" cascade>
        <!--Card image-->
        <div
          class="price white-text rounded-top"
          v-bind:style="{padding: '1rem 2rem', textAlign: 'left', background: '#026ab4', fontFamily: 'OpenSans-Regular', fontSize: '16px', lineHeight: '1.38'}"
        >
          <span>
            <img
              alt="icono obra"
              :src="imgServer+'apps/myfrac/admin/assets/Obra_Icon@3x.png'"
              class="img-fluid"
              style="width: 28px; height: 26px"
            />
          </span>
          &nbsp; {{headerTitle}}
          <div class="text-right" style=" margin-top: -10px; margin-right: -20px; float: right;">
            <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
              <span slot="tip">Descartar registro</span>
              <mdb-btn
                slot="reference"
                outline="white"
                rounded
                size="sm"
                class="px-2 style_BTN"
                @click="remove"
              >
                <mdb-icon icon="times" class="mt-0" />
              </mdb-btn>
            </mdb-tooltip>
          </div>
        </div>

        <!--/Card image-->

        <!--Card content-->
        <mdb-card-body>
          <form id="form2" class="needs-validation" novalidate @submit="checkFormConstruction">
            <mdb-row class="form-row">
              <!--Form content-->
              <mdb-col md="6">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro">Datos del registro</p>
                  </mdb-row>
                </mdb-col>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="constructionName"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Nombre de la obra</label>
                      <input
                        type="text"
                        class="form-control text-input"
                        id="constructionName"
                        required
                        placeholder="Nombre de la obra"
                        maxlength="64"
                        v-model="form.nameConstruction"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="street"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Calle de la obra</label>
                      <model-select
                            :options="streets"
                            class="text-input"
                            v-model="streetModel"
                            style="height: 37px; margin-top: 10px;"
                            placeholder="Selecciona una calle"
                            :isError="streetValid"
                          ></model-select>
                      <div class="valid-feedback">Correcto</div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="street"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Número de obra</label>
                      <input
                        type="number"
                        class="form-control text-input"
                        id="NConstruction"
                        required
                        placeholder="Número de obra"
                        maxlength="64"
                        v-model="form.number"
                        :disabled="disabledNumber"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-col>
              <mdb-col md="6">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro"></p>
                  </mdb-row>
                </mdb-col>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="lastName"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Nombre del contratista</label>
                        <model-select
                            :options="contractors"
                            class="text-input"
                            v-model="contractorModel"
                            style="height: 37px; margin-top: 10px;"
                            placeholder="Selecciona un contratista"
                            :isError="contractorValid"
                          ></model-select>
                      <div class="valid-feedback">Correcto</div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="numberStreet"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Número de terreno</label>
                      <input
                        type="number"
                        class="form-control text-input"
                        id="numberStreet"
                        required
                        placeholder="Número de terreno"
                        maxlength="10"
                        v-model="form.numberStreet"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 50%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label for="startDate" style="font-family: OpenSans-Semibold;">Periodo estimado *</label>
                          <div style="display: grid; grid-template-columns: auto auto;">
                          <mdb-date-picker
                            id="startDate"
                            outline
                            label="De"
                            @getValue="getStartDate"
                            :option="optionsDate"
                            :validation="validationDate_start"
                            :isValid="startDateValid"
                            v-model="form.date_start"
                            :limit="limitDate"
                            v-bind:style="{ marginTop: '-12%', fontSize: '12px', width: '100px' }"
                          />
                        <mdb-date-picker
                            id="endDate"
                            label="A"
                            outline
                            @getValue="getEndDate"
                            :option="optionsDate"
                            :validation="validationDate_end"
                            :isValid="endDateValid"
                            v-model="form.date_end"
                            :limit="limitDate_2"
                            :disableOk="disabledDate"
                            :disableToday="disabledDate"
                            v-bind:style="{ marginTop: '-12%', fontSize: '12px', width: '100px'}"
                          />
                          </div>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-col>
            </mdb-row>
            <mdb-row style="padding-left: 25%">
              <mdb-col md="2" style="margin-right: 2rem;">
                <button
                  type="button"
                  class="waves-effect waves-dark btn btn-next btn-color-prev"
                  @click="remove"
                >Cancelar</button>
              </mdb-col>
              <mdb-col md="2" style="margin-left: 2rem;">
                <mdb-btn
                  type="submit"
                  class="waves-effect waves-dark btn btn-next btn-color-next"
                >{{buttonTitle}}</mdb-btn>
              </mdb-col>
              <!--Buttons content-->
            </mdb-row>
          </form>
        </mdb-card-body>
        <!--/.Card content-->
      </mdb-card>
      <!--/.Card-->
    </section>
    <!--Section: Horizontal stepper-->
    <!--Modal edit invited -->
  </mdb-container>
</template>
<script>
/* eslint-disable */
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import { ModelSelect } from "vue-search-select";
import {
  mdbContainer,
  mdbTooltip,
  mdbView,
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  mdbInput,
  mdbRow,
  mdbCol,
  mdbTextarea,
  mdbIcon,
  mdbBtn,
  mdbDatePicker,
} from "mdbvue";

export default {
  name: "createConstruction",
  components: {
    mdbTooltip,
    mdbContainer,
    mdbView,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbInput,
    mdbTextarea,
    mdbRow,
    mdbCol,
    mdbIcon,
    mdbBtn,
    mdbDatePicker,
    ModelSelect,
  },
  data() {
    return {
      headerTitle: "Registrar obra",
      buttonTitle: "Registrar",
      urlServer: Servers.serverApi,
      imgServer: Servers.serverImg,
      disabledEmail: false,
      startDateValid: false,
      endDateValid: false,
      validationDate_start: false,
      validationDate_end: false,
      disabledDate:true,
      disabledNumber: false,
      streets:[],
      contractors:[],
      streetModel: {
        value: "",
        text: ""
      },
      contractorModel: {
        value: "",
        text: ""
      },
      streetValid:false,
      contractorValid:false,
      form: {
        uuid:"",
        nameConstruction: "",
        street: "",
        idContractor: "",
        date_start: "",
        date_end: "",
        number: "",
        numberStreet: ""
      },
       limitDate: [
        {
          type: "fromto",
          from: "",
          to: "2100-12-30"
        }
      ],
      limitDate_2: [
        {
          type: "fromto",
          from: "",
          to: "2100-12-30"
        }
      ],
      optionsDate: {
        week: ["Lun", "Mar", "Mie", "Jue", "Vie", "Sab", "Dom"],
        month: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre"
        ],
        buttons: {
          ok: "Aceptar",
          clear: "Limpiar",
          cancel: "Cancelar",
          today: "Hoy"
        },
        format: "YYYY-MM-DD"
      },
    }; // END RETURN
  },
  methods: {
    getStreets() {
      let aux = this;
      Axios.get(this.urlServer + "api/streets", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          for (var i = 0; i < response.data.length; i++) {
            var temp = {
              value: response.data[i].uuid,
              text: response.data[i].name
            };
            aux.streets.push(temp);
          }
        })
        .catch(error => {
          console.log(error.response);
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
    },
    getContractors() {
      let aux = this;
       Axios.get(Servers.serverApi + "api/contractors/", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          for (var i = 0; i < response.data.length; i++) {
            var temp = {
              value: response.data[i].uuid,
              text: response.data[i].firstName + ' '+ response.data[i].lastName
            };
            aux.contractors.push(temp);
          }
        })
        .catch(error => {
          console.log(error.response);
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
    },
     getStartDate(val) {
      if (val) {
        this.startDateValid = true;
        this.limitDate_2[0].from = val;
        this.disabledDate = false;
      } else {
        this.form.date_start = "";
        this.startDateValid = false;
      }
    },
    getEndDate(val) {
      if (val) {
        this.endDateValid = true;
      } else {
        this.form.date_end = "";
        this.endDateValid = false;
      }
    },
    getOneConstriction(uuid){
       let aux = this;
      return Axios.get(this.urlServer + "api/constructions/" + uuid, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(response => {
          aux.streetModel.value = response.data.street.uuid
          aux.streetModel.text = response.data.street.name
          aux.contractorModel.value = response.data.contractor.uuid
          aux.contractorModel.text = response.data.contractor.firstName + ' '+ response.data.contractor.lastName
          aux.form.uuid = response.data.uuid
          aux.form.nameConstruction = response.data.name
          aux.form.date_start = response.data.startDate
          aux.form.date_end = response.data.endDate
          aux.form.number = response.data.streetNumber
          aux.form.numberStreet = response.data.number

        
        })
        .catch(error => {
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });

    },
    remove() {
      window.location.href = "/constructions";
    },
    cleanForm() {
       window.location.href = "/constructions";
    },
    validateForm(){
      if(this.contractorModel.value ==""){
        this.contractorValid = true;
      }
      if(this.streetModel.value ==""){
        this.streetValid = true;
      }
      if(this.form.nameConstruction != ""&& this.form.date_start != "" && this.form.date_end != "" && this.contractorModel.value !="" && this.streetModel.value != "")
      return true;
      else
      return false; 

    },
    checkFormConstruction(event) {
      event.preventDefault();
      event.target.classList.add("was-validated");
      this.validationDate_start = true;
      this.validationDate_end = true;
      if(this.validateForm()){
      if(this.$route.query.token !=undefined){
         var data = {
        "name": this.form.nameConstruction,
        "contractor": {
          "uuid": this.contractorModel.value
        },
        "street":{
          "uuid": this.streetModel.value
        },
        "startDate": this.form.date_start,
        "endDate": this.form.date_end
        
      }
      let aux = this;

      Axios.put(this.urlServer + "api/constructions/"+this.$route.query.token, data, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          aux.showMessageSucces("¡Edición exitosa!","¡Construcción actualizada!");
          window.location.href = "/constructions"
        })
        .catch(error => {
          console.log(error.response);
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
      

      }
      else{

      var data = {
        "name": this.form.nameConstruction,
        "contractor": {
          "uuid": this.contractorModel.value
        },
        "number": this.form.numberStreet,
        "streetNumber": this.form.number,
        "street":{
          "uuid": this.streetModel.value
        },
        "startDate": this.form.date_start,
        "endDate": this.form.date_end
        
      }
      let aux = this;

      Axios.post(this.urlServer + "api/constructions", data, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          aux.showMessageSucces("¡Registro exitoso!","La construcción ha sido creada correctamente");
           window.location.href = "/constructions"

         
        })
        .catch(error => {
          console.log(error.response);
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
      }
      }
    },
     showMessageError: function(text, error) {
      let aux = this;
      let errorText;
      Swal.fire({
        title: "<span style='font-size: 20px'>" + text + "</span>",
        html: "<span style='font-size: 12px'>" + error + "</span>",
        imageUrl: Servers.serverImg+"apps/myfrac/admin/assets/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        //confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {}
      });
    },
    showMessageSucces: function(title, text) {
      Swal.fire({
        title: "<span style='font-size: 20px;'>"+title+"</span>",
        html: "<span style='font-size: 12px;'>" + text + "</span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () =>{
        
        }
      });
    }
    
  },
  created() {
        var offset = new Date().getTimezoneOffset() * 60000;
     this.limitDate[0].from = new Date(new Date() - offset)
      .toISOString()
      .split("T")[0];
      this.getStreets();
      this.getContractors();
  },
  mounted() {

     if (this.$route.query.token != undefined) {
       this.disabledNumber=true;
       this.headerTitle="Editar obra"
       this.buttonTitle="Guardar"
      this.getOneConstriction(this.$route.query.token);
     }

  },
  update() {},
  watch: {
    streetModel(newStreet) {
      this.streetModel = newStreet;
      if (newStreet.value || newStreet.text !== "") {
        this.streetValid = false;
      } else {
        this.streetValid = true;
      }
    },
    contractorModel(newPlace) {
      this.contractorModel = newPlace;
      if (newPlace.value || newPlace.text !== "") {
        this.contractorValid = false;
      } else {
        this.contractorValid = true;
      }
    },
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.modal-header {
  width: 112%;
  height: 44px;
  background-color: #67a3cf;
  margin-left: -6%;
  margin-bottom: 20px;
  margin-top: -20px;
}

</style>
<style>
.Datos-del-registro {
  width: auto;
  height: 19px;
  font-family: OpenSans-Bold;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}


.btn.btn-edit {
  padding: 0.2rem 0.4rem;
  font-size: 0.64rem;
  border-radius: 7px;
  width: 24px;
  height: 23p;
}

.form-csv {
  height: 170px;
  width: 300px;
  margin: 0 auto;
  border-radius: 2px;
  border: 1px solid #e8e9ec;
  background-color: #ffffff;
}

.form-csv h5,
.form-csv h6 {
  width: 100%;
  color: #545871;
}

.form-csv input {
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100px;
  outline: none;
  opacity: 0;
}

.form-csv input:hover {
  cursor: pointer;
}

.form-csv:hover {
  opacity: 0.7;
  border: 4px dashed #676d6d;
}

.Rectangle-536 {
  width: 190px;
  height: 37px;
  border-radius: 4px;
  border: solid 1px #e8e9ec;
  background-color: #ffffff;
}

.Rectngulo-1673 {
  width: 161.6px !important;
  height: 37px !important;
  border-radius: 3px !important;
  border: solid 1px #e8e9ec;
  background-color: #ffffff;
}

.Rectngulo-650 {
  width: 1112.7px;
  height: 500.8px;
  border-radius: 25px;
  border: solid 2px #bce0fd;
  background-color: #ffffff;
}

.save-btn {
  font-size: 10px;
  float: right;
}



.text-width {
  width: auto;
}

.text-input {
  width: auto;
}

.btn-next {
  text-transform: capitalize !important;
  border-radius: 7px !important;
  width: 110px !important;
  height: 39px !important;
  padding: 0px 0px !important;
}

.btn-prev {
  text-transform: capitalize !important;
  border-radius: 7px !important;
  width: 110px !important;
  height: 39px !important;
  padding: 0px 0px !important;
}

.btn-final {
  text-transform: capitalize !important;
  border-radius: 7px !important;
  width: 110px !important;
  height: 39px !important;
  padding: 0px 0px !important;
}

.btn-color-next {
  background-color: #23a7ed !important;
  color: #fff !important;
}

.btn-color-prev {
  background-color: #ed5f5f !important;
  color: #fff !important;
}

.btn-modal-accept {
  height: 50% !important;
  width: auto !important;
  background-color: #3085d6 !important;
  font-size: 12px !important;
}

.btn-modal-cancel {
  height: 50% !important;
  width: auto !important;
  background-color: #d33 !important;
  font-size: 12px !important;
}

.btn-modal-download {
  height: 50% !important;
  width: auto !important;
  background-color: #a4a8ab !important;
  font-size: 12px !important;
}

.style_BTN {
  width: 31.2px;
  object-fit: contain;
}


.card-person{
    width: 536px !important;
    margin-left: 15rem !important;

}

.ui.dropdown .menu > .item {
  font-size: 12px !important;
}

.mdb-vue-date label{
  font-size: 12px !important;
}



</style>
